import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";
import { RootState } from "store/Store";
import { FeatureResolution } from "types/cx-editor";

export interface FeatureMetricsReducerState {
  level1Data: FeatureResolution[] | null;
  level2Data: FeatureResolution[] | null;
  loading: boolean;
  error: string | null;
  lastFetchedPilotId: string | null;
}

const defaultState: FeatureMetricsReducerState = {
  level1Data: null,
  level2Data: null,
  loading: false,
  error: null,
  lastFetchedPilotId: null,
}

export const featureMetricsSlice = createSlice({
  name: 'featureMetrics',
  initialState: defaultState,
  reducers: {
    setLevel1Data: (state, action: PayloadAction<FeatureResolution[]>) => {
      state.level1Data = action.payload;
      state.error = null;
    },
    setLevel2Data: (state, action: PayloadAction<FeatureResolution[]>) => {
      state.level2Data = action.payload;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setLastFetchedPilotId: (state, action: PayloadAction<string>) => {
      state.lastFetchedPilotId = action.payload;
    },
    clearFeatureMetrics: (state) => {
      state.level1Data = null;
      state.level2Data = null;
      state.loading = false;
      state.error = null;
      state.lastFetchedPilotId = null;
    }
  }
}) as any;

export const {
  setLevel1Data,
  setLevel2Data,
  setLoading,
  setError,
  setLastFetchedPilotId,
  clearFeatureMetrics
} = featureMetricsSlice.actions;

export const selectLevel1Data = (state: RootState) => (state.featureMetrics as FeatureMetricsReducerState).level1Data;
export const selectLevel2Data = (state: RootState) => (state.featureMetrics as FeatureMetricsReducerState).level2Data;
export const selectFeatureMetricsLoading = (state: RootState) => (state.featureMetrics as FeatureMetricsReducerState).loading;
export const selectFeatureMetricsError = (state: RootState) => (state.featureMetrics as FeatureMetricsReducerState).error;
export const selectLastFetchedPilotId = (state: RootState) => (state.featureMetrics as FeatureMetricsReducerState).lastFetchedPilotId;

